// Stok Hareketi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.stockMovement';

export const inventoryStockMovementGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Stok hareketi nasıl kaydedilir?'),
  intro: t(`${G}.intro`, 'Bu ekran ile stok giriş ve çıkış işlemlerini kayıt altına alabilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve hareket yönü'),
    body: t(`${G}.regions.body`, 'Hareket bilgileri'),
    footer: t(`${G}.regions.footer`, 'Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hareket yönünü seçin'),
      text: t(`${G}.s1.text`, 'Önce başlıktaki listeden hareket yönünü seçin: "Stok Giriş" (ör. tedarikçiden gelen mal) veya "Stok Çıkış" (ör. fire, kayıp, bozulma). Yön seçilmeden form alanları açılmaz.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Tarih, miktar ve fiyat'),
      text: t(`${G}.s2.text`, 'Tarih ve saati kontrol edin, hareket miktarını girin. Ardından birim fiyatı girin: girişte "Alış Fiyatı", çıkışta "Satış Fiyatı" sorulur; ürünün kayıtlı fiyatı otomatik gelir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Evrak numarası ve açıklama'),
      text: t(`${G}.s3.text`, 'Evrak numarası otomatik oluşur (STK-…); isterseniz düzenleyerek şirket içi takip numaranıza uyarlayabilirsiniz. Açıklama alanına hareketin nedenini yazın.'),
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Özeti kontrol edin'),
      text: t(`${G}.s4.text`, 'Özet alanında toplam tutarı ve "Mevcut → Yeni" stok miktarını görürsünüz. Kaydetmeden önce buna bakarak hatalı kayıt riskini azaltın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kaydedin'),
      text: t(`${G}.s5.text`, '"Kaydet" ile hareketi kaydedin; ürünün stok miktarı güncellenir. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
